var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.383 1.006V.671c0-.16.129-.288.288-.288h1.342L2.126.16C2.173.061 2.273 0 2.382 0h1.37c.108 0 .208.061.257.16l.113.223h1.342c.159 0 .287.129.287.288v.335c0 .08-.065.144-.144.144H.527c-.079 0-.144-.064-.144-.144zm4.985.671V5.56c0 .318-.258.576-.575.576H1.342c-.318 0-.575-.258-.575-.576V1.677c0-.079.065-.143.144-.143h4.313c.079 0 .144.064.144.143zm-3.26.815c0-.105-.086-.192-.191-.192-.105 0-.192.087-.192.192v2.684c0 .105.087.192.192.192.105 0 .192-.087.192-.192V2.492zm1.151 0c0-.105-.086-.192-.192-.192-.105 0-.191.087-.191.192v2.684c0 .105.086.192.191.192.106 0 .192-.087.192-.192V2.492zm1.15 0c0-.105-.086-.192-.192-.192-.105 0-.191.087-.191.192v2.684c0 .105.086.192.191.192.106 0 .192-.087.192-.192V2.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/trash-alt.ed5e68b1b3a90a90ae1e2586c9882237.svg";
export { ForwardRef as ReactComponent };